export const PRODUCT_NAME = 'Fomoalert';